import React, { useState, useEffect } from "react";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../api/rootApi";

const ManageOrder = () => {
  const [booking, setBooking] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    fetch(`${BASE_URL}/allBookingProduct`)
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        setBooking(result);
      });
  }, [booking]);

  const handleUpdate = (id) => {
    fetch(`${BASE_URL}/booking/${id}`, {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(user),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.modifiedCount) {
          alert("Status Updated!");
        }
      });
  };

  return (
    <div className="container mx-auto py-10 px-4 sm:px-6">
      <div className="mb-10">
        <h2 className="text-3xl font-bold text-slate-900 tracking-tight">Manage All Orders</h2>
        <p className="text-slate-500 mt-2">Overview of all customer bookings and their current status.</p>
      </div>
      
      {booking.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {booking.map((book) => (
            <div
              key={book?._id}
              className="bg-white shadow-sm hover:shadow-md transition-shadow duration-300 rounded-2xl p-6 border border-slate-200/60 flex flex-col"
            >
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-xl font-bold text-slate-900 line-clamp-1">
                  {book?.title}
                </h3>
                <span className={`px-2.5 py-1 text-xs font-bold rounded-md whitespace-nowrap ${book?.status === "Pending" ? "bg-amber-50 text-amber-700 border border-amber-200" : "bg-emerald-50 text-emerald-700 border border-emerald-200"}`}>
                  {book?.status || "Unknown"}
                </span>
              </div>
              
              <div className="space-y-3 mb-6 flex-1 text-sm text-slate-600">
                <div className="flex items-center gap-2">
                  <span className="text-slate-400">👤</span>
                  <span className="font-medium text-slate-700">{book?.name}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-slate-400">✉️</span>
                  <span>{book?.email}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-slate-400">📍</span>
                  <span className="line-clamp-1">{book?.address}</span>
                </div>
                <div className="flex items-center gap-2 pt-2 border-t border-slate-100 mt-2">
                  <span className="text-slate-400">💰</span>
                  <span className="font-bold text-slate-900">{book?.price}</span>
                </div>
              </div>
              
              <div className="mt-auto pt-4 border-t border-slate-100">
                {book?.status === "Pending" ? (
                  <button
                    onClick={() => handleUpdate(book._id)}
                    className="w-full py-3 rounded-xl bg-slate-900 text-white font-semibold text-sm hover:bg-amber-500 hover:text-slate-900 transition-all duration-300 flex items-center justify-center gap-2"
                  >
                    Mark as Shipped
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                  </button>
                ) : (
                  <button
                    disabled
                    className="w-full py-3 rounded-xl bg-slate-50 text-emerald-600 font-semibold text-sm flex items-center justify-center gap-2 cursor-not-allowed border border-slate-100"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                    Shipped
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-slate-200/60 p-12 text-center">
          <p className="text-lg text-slate-500">No orders found.</p>
        </div>
      )}
    </div>
  );
};

export default ManageOrder;
